import type {PayloadAction} from '@reduxjs/toolkit';
import {createSlice} from '@reduxjs/toolkit';
import type {AdminSettingState} from '@local/redux/state/pages/adminSetting';

// 初期ステートをこういう感じにするとページ増えたときのredux層の情報量が増えるけど
// 数百万件とか裁こうとしてる中でこういうのが多少あってもそもそも変わらんし
// ページ遷移時の遅延がない（最初から初期状態は持ってる）ほうがいいし
// stateなし、初期ロード前、ロード後の3段階管理する複雑さによる開発への影響と
// その結果の品質への影響のほうが大きいので、こうする。
const initialState: AdminSettingState = {
  init: false,
  countFrom: 0,
  countTo: 0,
  totalCount: 0,
  page: 1,
  pageFrom: 1,
  pageTo: 1,
  totalPage: 1,
  people: [],
  checked: [],
  checkAll: false,
  checkExcludes: [],
  newAdminDialog: false,
  newAdmins: [],
  registering: false,
  deleting: false,
  dialogTooltipOpen: false,
  deleteAdminDialogOpen: false,
};
const adminSettingSlice = createSlice({
  name: 'adminSetting',
  initialState,
  reducers: {
    set: (state, action: PayloadAction<Partial<AdminSettingState>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    clear: () => initialState,
  },
});
export const adminSettingReducer = adminSettingSlice.reducer;
export const adminSettingActions = adminSettingSlice.actions;
